<template>
  <div>
    <v-sheet>
      <v-container fluid>
        <v-subheader>Reportes Totales por periodo</v-subheader>
        <v-row>
          <v-col cols="12" md="3">
            <select-dates></select-dates>
          </v-col>
          <v-col cols="12" md="9">
            <reportes-ventas></reportes-ventas>
          </v-col>
        </v-row>
        <v-divider class="my-2"></v-divider>
        <v-subheader>Reportes Totales Actuales</v-subheader>
        <v-row>
          <v-col cols="12" md="12">
            <reportes-actuales></reportes-actuales>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
import DateSelect from '@/pages/reportes/SelectComponent'
import Ventas from '@/pages/reportes/VentasComponent'
import Actuales from '@/pages/reportes/ActualComponent'

export default {
  name: 'ReportesMainComponent',
  components: {
    'select-dates': DateSelect,
    'reportes-ventas': Ventas,
    'reportes-actuales': Actuales,
  },
  data () {
    return {
      //
    }
  },
}
</script>

